import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { Set } from '../../../ts/models/Set';
import { ActivateSitesAction } from '../../../ts/siteManagement/services/ActivateSitesAction';
import { DeleteSitesAction } from '../../../ts/services/DeleteSitesAction';
import { EditSiteAction } from '../../../ts/services/EditSiteAction';
import { SuspendSitesAction } from '../../../ts/siteManagement/services/SuspendSitesAction';
import { SiteActivate, SiteDelete, SiteEdit, SiteSuspend } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { SiteMenuAction } from '../../actions/spaces/SiteMenuActions';
import { ServiceLocator } from '../../ServiceLocator';
import { Sites } from '../../../ts/resources/Sites';

export function* handleSuspend(action: SiteMenuAction): SagaIterator {
  try {
    yield call(suspendSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function suspendSite(sites: ISiteSettingsForServerAdmin[]) {
  const context = ServiceLocator.getAngularActionContext();
  return SuspendSitesAction.showSuspendSitesActionDialog(Set.fromIdItemArray(sites));
}

export function* handleActivate(action: SiteMenuAction): SagaIterator {
  try {
    yield call(activateSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function activateSite(sites: ISiteSettingsForServerAdmin[]) {
  return ActivateSitesAction.showActivateSitesActionDialog(Set.fromIdItemArray(sites));
}

export function* handleEdit(action: SiteMenuAction): SagaIterator {
  try {
    yield call(editSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function editSite(sites: ISiteSettingsForServerAdmin[]) {
  const context = ServiceLocator.getAngularActionContext();
  // First call the getSiteSettingsForServerAdmin API so that EditSiteAction can be executed with latest settings
  return ServiceLocator.get<Sites>('Sites').getSiteSettingsForServerAdminById(sites[0].id)
    .then((siteSettings: ISiteSettingsForServerAdmin) =>
      ServiceLocator.get<EditSiteAction>('EditSiteAction')
        .execute(siteSettings, context)
    );
}


export function* handleDelete(action: SiteMenuAction): SagaIterator {
  try {
    yield call(deleteSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function deleteSite(sites: ISiteSettingsForServerAdmin[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<DeleteSitesAction>('DeleteSitesAction')
    .execute(Set.fromIdItemArray(sites), context);
}

export function* rootSiteMenuActionSaga(): SagaIterator {
  yield takeEvery(SiteSuspend, handleSuspend);
  yield takeEvery(SiteActivate, handleActivate);
  yield takeEvery(SiteEdit, handleEdit);
  yield takeEvery(SiteDelete, handleDelete);
}
